import React, { useState } from 'react';

import { Form } from 'react-bootstrap';

import { Activity } from '../../types/Activity';
import CollapsableItem from '../utils/CollapsableItem';

import ActivityFormField from './ActivityForm/ActivityFormField';
import ActivitySectionButtons from './ActivitySectionButtons';

type Field = {
  name: 'faqContent';
  value: string;
};

type Faq = Pick<Activity, 'faqContent'>;

type Props = Faq & {
  isMobile: boolean;
  updateActivity: (fields: Partial<Activity>) => Promise<Activity | undefined>;
};

export default function ActivityFAQFormSection({
  faqContent: _faqContent,
  isMobile,
  updateActivity,
}: Props) {
  const [faq, setFaq] = useState<Faq>({
    faqContent: _faqContent,
  });
  const { faqContent } = faq;
  const canSubmitForm = faqContent === _faqContent;

  const handleUpdateField = (fields: Field[]) => {
    const updatedFaq = Object.fromEntries(
      fields.map(({ name, value }) => [name, value])
    );

    setFaq({ ...faq, ...updatedFaq });
  };

  const handleResetForm = () => {
    setFaq({
      faqContent: _faqContent,
    });
  };

  const handleSaveForm = async event => {
    event.preventDefault();

    const experience = await updateActivity({ faqContent });

    if (experience) {
      setFaq({
        ...faq,
        faqContent: experience.faqContent,
      });
    }
  };

  return (
    <div className='data-box'>
      <div className='activity-section-top'>
        <h4 className='header'>
          {isMobile ? 'FAQ' : 'Frequently Asked Questions'}
        </h4>
        <ActivitySectionButtons
          disabled={canSubmitForm}
          onResetClick={handleResetForm}
          onSaveClick={handleSaveForm}
        />
      </div>
      <CollapsableItem isExpanded={!isMobile}>
        <Form>
          <ActivityFormField
            isMobileView={isMobile}
            isMobileEditMode
            labelStyle={{}}
            label='Content'
            name='faqContent'
            onMetaFieldsChange={handleUpdateField}
            value={faqContent}
          />
        </Form>
      </CollapsableItem>
    </div>
  );
}
